import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../styles/Setting.css'
import { StaticGoalCalculate } from "../../functions/getStreak";
import { useProject } from "../../hooks/useProject";
import { useProjectsContext } from "../../context/ProjectsContext";
import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader";
import ChapterSettings from '../../components/projectSettings/ChaptersSettings/ChaptersSettings';
import DailyGoalSettings from "../../components/projectSettings/DailyGoalSettings/DailyGoalSettings";
import DeleteProjectModal from "../../components/projectSettings/DeleteProjectModal/DeleteProjectModal";



import { Link } from "react-router-dom";

import { IoIosArrowBack } from "react-icons/io";
import { MdDelete } from "react-icons/md";
import { FaEdit } from "react-icons/fa";
import { FaCheck } from "react-icons/fa";

import Flower from '../../components/common/Flower/Flower';
import ClickFlower from '../../components/common/ClickFlower/ClickFlower';

export default function Setting(){

const {index, project, updateProject} = useProject();
const { deleteProject } = useProjectsContext();
const[showModal, setShowModal] = useState(false);
const navigate = useNavigate();

const [ChaptersEnabled, setChapterEnabled] = useState(false);
const [minWords, setMinimum] = useState(0);

const [GoalEnabled, setGoalEnabled] = useState(false);
const [GoalMode, setGoalMode] = useState("Auto");
const [GoalValue, setGoalValue] = useState(0);
const [ShouldRecalculate, setRecalculate] = useState(false);

  useEffect(() => {
    if (!project) return;

    setChapterEnabled(project.settings.chaptersEnabled);
    setMinimum(project.settings.MinimumWordsInChapter);

    setGoalEnabled(project.settings.goalEnabled);
    setGoalMode(project.settings.goalMode);

    if (project.settings.goalMode !== "Static") {
    setGoalValue(project.settings.dailyGoal);
    }
  }, [project]);

  


if (!project) {
    return <div>Projekt nie istnieje</div>;
}
const EditProject=()=>{
    const editedProject = {...project};
    editedProject.settings.chaptersEnabled = ChaptersEnabled;
    editedProject.settings.MinimumWordsInChapter = minWords;
    editedProject.settings.goalEnabled = GoalEnabled;
    if((GoalMode == "Static" || GoalMode == "Auto") && project.finishDate == ""){
        alert("Musisz podać datę ukończenia projektu by wybrać ten typ celu");
        return;
    }
    if(GoalMode == "Static" || GoalMode == "Auto"){
        const GoalValue = StaticGoalCalculate(project);
        setGoalValue(GoalValue);
    }
    editedProject.settings.goalMode = GoalMode;    
    editedProject.settings.dailyGoal = GoalValue;

    if(ChaptersEnabled && editedProject.chapters.length == 0){
        editedProject.chapters = [];
    }
    updateProject(editedProject);
    navigate(-1);
}

    return (
        <div className="projectlist-wrapper">
        <ProjectHeader
        headerTitle={'Ustawienia'}
        showBackButton={true}
        path={`/offline/project/${index}`}
        />
         
        <div className="SettingsForm" style={{marginTop: '100px'}}> 
            <div className="section"> 
                <ChapterSettings
                ChaptersEnabled={ChaptersEnabled}
                setChaptersEnabled={setChapterEnabled}
                minWords={minWords}
                setMinimum={setMinimum}
                />
            </div>

            <div className="section"> 
                <DailyGoalSettings
                GoalEnabled={GoalEnabled}
                setGoalEnabled={setGoalEnabled}
                GoalMode={GoalMode}
                setGoalMode={setGoalMode}
                GoalValue={GoalValue}
                setGoalValue={setGoalValue}
                setRecalculate={setRecalculate}
                onRefresh={() => {
                    const calculatedGoal = StaticGoalCalculate(project);
                    setGoalValue(calculatedGoal);
                }}
                />
            </div>
            

            <div className="buttons-row">
                <button 
                    onClick={() => setShowModal(true)}>
                    <MdDelete/> Usuń projekt
                </button>
                <button onClick={()=>navigate(`/offline_edit/project/${index}`)}> <FaEdit/> Edytuj projekt </button>
                <button onClick={EditProject}> <FaCheck/> Zatwierdź zmiany </button>
            </div>

            {showModal && (

            <DeleteProjectModal
                setShowModal={setShowModal}
                onDelete={()=>{
                    setShowModal(false);
                    deleteProject(index);
                    navigate(`/local`);
                }}
            />
            
            )}
        </div>
        

        
        
        <Link to={`/offline/project/${index}`} className="BackfixButton"><IoIosArrowBack /></Link>

        <Flower
          flowerClass={"flower1"}/>
        <Flower
          flowerClass={"flower2"}/>
        <ClickFlower/>

        </div>
    )
}